module.exports = __webpack_public_path__ + "img/dislike.d54b2a35.svg";